import { render, staticRenderFns } from "./fontSettings.vue?vue&type=template&id=477007a8"
import script from "./fontSettings.vue?vue&type=script&lang=js"
export * from "./fontSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports